export default __webpack_public_path__ + "8b343ae402849c7e29ff13fce3e6b4b2.png";